export const observeProperty = (target, key, callback, defaultVal) => (
    Object.defineProperty(target, `_${key}`, {
        value: defaultVal,
        writable: true,
        configurable: false,
        enumerable: false
    }) &&
    Object.defineProperty(target, key, {
        get: function () {
            return this[`_${key}`];
        },
        set: function (value) {
            this[`_${key}`] = value;
            callback.call(this, value, key);
        },
        configurable: true,
        enumerable: true
    })
);

export const filterObject = (obj, predicate, negative) => {
    let key;
    const result = {};

    for (key in obj) {
        if (obj.hasOwnProperty(key) && (predicate(obj[key], key, obj) || negative)) {
            result[key] = obj[key];
        }
    }

    return result;
};

export const removeArrayElement = (array, element) => {
    if (!Array.isArray(array)) {
        throw new TypeError('First argument must be of type `Array`');
    }

    const clone = [...array];
    const index = clone.indexOf(element);

    if (index !== -1) {
        clone.splice(index, 1);
    }

    return clone;
};

export const fromEntries = (iterable) => {
    return [...iterable]
        .reduce((obj, { 0: key, 1: val }) => Object.assign(obj, { [key]: val }), {})
};

export const filterDuplicates = array => array.filter((item, index) => array.indexOf(item) === index);

export const readOnlyProperty = (target, propertyKey) => (
    Reflect.defineProperty(target, propertyKey, {
        writable: false,
        configurable: false
    })
);